export type EventOrganizerPriority = 'low' | 'medium' | 'high' | 'critical';

export const eventOrganizerPriorities: EventOrganizerPriority[] = [
  'low',
  'medium',
  'high',
  'critical',
];

export interface IEventOrganizer {
  id?: number;
  name: string;
  mainImagePath?: string | null;
  priority: EventOrganizerPriority;
  // API exposes `enabled` on the element response (flips to false on soft delete)
  // so the list can render deleted rows with a visual marker.
  enabled?: boolean;
  createdAt?: string;
  createdAtLocal?: string;
}
